import { Clipboard } from '@angular/cdk/clipboard';
import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { CanPipe } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, ModalComponent, ModalFooterDirective, ToastService } from 'mbs-ui-kit';
import { msiDocumentationUrl } from '../download-build.constants';

@Component({
  selector: 'mbs-msi-download-info-modal',
  templateUrl: './msi-download-info-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, CanPipe, I18NextPipe, ModalComponent, ModalFooterDirective]
})
export class MsiDownloadInfoModalComponent {
  private clipboard = inject(Clipboard);
  private i18n = inject(I18NextPipe);
  private toastService = inject(ToastService);

  public readonly documentationUrl = msiDocumentationUrl;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public get command(): string {
    return this.baseModal.data?.command as string;
  }

  public copyCommand(): void {
    this.clipboard.copy(this.command);
    this.toastService.success(this.i18n.transform('shared:download-build.copiedCommand'));
  }

  public continue(): void {
    this.baseModal.save();
  }

  public cancel(): void {
    this.baseModal.close();
  }
}
